export const customTableStyles = {
  headCells: {
    style: {
      fontSize: "14px",
      fontFamily: "notosanslao",
      background: "#eeeeee",
      fontWeight: "600",
      border: "0.5px solid #dee2e6",
    },
  },
  cells: {
    style: {
      cursor: "pointer",
      fontFamily: "notosanslao",
      fontSize: "14px",
      border: "0.5px solid #eeeeee",
    },
  },
  table: {
    style: {
      minHeight: "400px",
    },
  },
};
